module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAz0lEQVRYhe3X0QmDMBAG4D/SARzFAXxxlC5QcIN2AsEJ3MQXB3AUN7AIaakkamL07ir5H+Ugnx7hPMTEXC1qz/uMjzwFUAEoVd0NRkFAbjsxLYBMP7obRQFJAjD99IWMosA4t8yCKY5uF1xBVBgnECVmE0SNWQVxYBZBXBgriBNjgLgxM5AEzBdkGQeUeam6e37O8xodFJHZMkko2ddeAsoK4kQtgrhQqyAO1P/9oFGjvNYgCpTX6NCHFxqT6d3s0HjPsh9Uc8YaFBNzrQB4A7oaisR2NOoPAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/@2x/ic_btn_arrow_left@2x.png
// module id = 719
// module chunks = 0